// Marks webshop carts so the cart milestone discount can leave out draft (phone) orders, which never carry
// this attribute, and records the running milestone so Shopify recalculates a cart when it starts, changes,
// stops or expires (Shopify keeps a cart's discounts until the cart changes).
(function () {
  if (window.msStorefrontCartMarker) return;

  const KEY = "_ms_storefront";
  const VALUE = "1";
  const MILESTONE_KEY = "_ms_milestone";
  const MILESTONE_SECTION = "ms-cart-milestone-key";
  const CART_UPDATED = (typeof CART_EVENT !== "undefined" && CART_EVENT.cartUpdate) || "maximize:cart:updated";
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  let pending = null;
  let rerun = false;
  let cartChanges = 0;

  function cartSections() {
    const helper = window.xCartHelper;
    if (!helper || typeof helper.getSectionsToRender !== "function") return [];
    const owner = document.getElementById(
      window.Maximize && window.Maximize.isCartPage ? "MainCart__Items" : "CartDrawer",
    );
    if (!owner || !owner.dataset.sectionId) return [];
    return helper.getSectionsToRender(owner.dataset.sectionId);
  }

  function renderSections(sectionsToRender, sections) {
    if (!sections || typeof getSectionInnerHTML !== "function") return;
    sectionsToRender.forEach((section) => {
      const element = document.querySelector(section.selector);
      if (!element || !sections[section.id]) return;
      const html = getSectionInnerHTML(sections[section.id], section.selector);
      if (section.selector === "#CartDrawer" && typeof window.xCartHelper.renderCartDrawer === "function") {
        window.xCartHelper.renderCartDrawer(element, html);
      } else {
        element.innerHTML = html;
      }
    });
  }

  function decodeHtml(value) {
    return value
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&");
  }

  function fetchMilestoneKey() {
    return fetch(root + "?sections=" + MILESTONE_SECTION, { headers: { Accept: "application/json" } })
      .then((response) => (response.ok ? response.json() : null))
      .then((sections) => {
        const match = sections && /data-ms-milestone-key="([^"]*)"/.exec(sections[MILESTONE_SECTION] || "");
        return match ? decodeHtml(match[1]) : null;
      });
  }

  function ensure() {
    if (pending) {
      rerun = true;
      return pending;
    }
    // A cart change in flight renders newer data; its update event triggers the next check.
    if (window.xCartHelper && window.xCartHelper.isUpdating) return null;

    const changesAtStart = cartChanges;
    pending = Promise.all([
      fetch(root + "cart.js", { headers: { Accept: "application/json" } }).then((response) =>
        response.ok ? response.json() : null,
      ),
      fetchMilestoneKey(),
    ])
      .then(([cart, milestoneKey]) => {
        if (!cart || !cart.item_count) return null;
        const attributes = cart.attributes || {};
        const changes = {};
        if (attributes[KEY] !== VALUE) changes[KEY] = VALUE;
        if (milestoneKey !== null && attributes[MILESTONE_KEY] !== milestoneKey) changes[MILESTONE_KEY] = milestoneKey;
        if (!Object.keys(changes).length) return null;

        const sectionsToRender = cartSections();
        return fetch(root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ attributes: changes, sections: sectionsToRender.map(({ id }) => id) }),
        })
          .then((response) => (response.ok ? response.json() : null))
          .then((updated) => {
            if (!updated) return;
            // Discounts, totals, the bar and its labels can all differ now. A cart change made meanwhile
            // has rendered newer data, so this response is dropped and the check runs again instead.
            if (cartChanges === changesAtStart) {
              renderSections(sectionsToRender, updated.sections);
            } else {
              rerun = true;
            }
          });
      })
      .catch(() => null)
      .finally(() => {
        pending = null;
        if (rerun) {
          rerun = false;
          ensure();
        }
      });
    return pending;
  }

  // The cart icon opens the drawer without an event, so watch the drawer's own open state instead.
  function watchDrawer() {
    const drawer = document.getElementById("CartDrawer");
    if (!drawer || typeof MutationObserver === "undefined") return;
    let wasOpen = drawer.hasAttribute("open");
    new MutationObserver(() => {
      const isOpen = drawer.hasAttribute("open");
      if (isOpen && !wasOpen) ensure();
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ["open"] });
  }

  window.msStorefrontCartMarker = { ensure };
  document.addEventListener(CART_UPDATED, () => {
    cartChanges += 1;
    ensure();
  });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") ensure();
  });
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) ensure();
  });
  watchDrawer();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ensure);
  } else {
    ensure();
  }
})();
